module.exports = __webpack_public_path__ + "static/locales/th.WYtmAX8.json";